export default __webpack_public_path__ + "c5794e7f722ac9ef4a68e5bd98fc2440.svg";